// extracted by mini-css-extract-plugin
module.exports = {"container":"Text_container__Y8v_-","toolbar":"Text_toolbar__1QC6-","toolbarButton":"Text_toolbarButton__2t0lF","editor":"Text_editor__1A49O","flex1":"Text_flex1__Ujw4u"};